module.exports = __webpack_public_path__ + "img/add.fb4887f8.png";